import { Box } from '@mantine/core';
import classes from './ChatWindow.module.css';

export interface ChatWindowProps {
  children: React.ReactNode;
}

export function ChatWindow({ children }: ChatWindowProps) {
  return <Box className={classes.root}>{children}</Box>;
}
